<div class="dialogWrapper" [ngClass]="data.type">
    <header>
        <i class="fa fa-warning"></i>
        <h2>{{ 'generalKeywords.delete' | translate }} {{ data.deletedEntityType | translate | lowercase }}</h2>
    </header>
    <div
        class="text-body"
        [innerHTML]="'generalKeywords.deleteBody' | translate: { entityType: data.deletedEntityType | translate | lowercase } | safeHtml"
    ></div>

    @if (data.deletedEntityValue) {
        <div class="deletedData">
            @if (data.deletedEntityValue[data.columns[0].dataKey] !== '') {
                <ng-container [appDataGridComponentInjector]="[data.columns[0], data.deletedEntityValue]" />
            }
            @if (data.isWithCompanyConfirmation) {
                <input
                    (keyup)="confirmationInputOnKeyUp($event)"
                    type="text"
                    [placeholder]="
                        data.shouldNotTranslatePlaceholder
                            ? data.confirmationInputPlaceholder
                            : (data.confirmationInputPlaceholder | translate)
                    "
                />
            }
        </div>
    }
    <footer>
        <button
            class="button delete-btn"
            (click)="close(true)"
            [disabled]="data.isWithCompanyConfirmation && confirmationInput !== ('generalKeywords.delete' | translate)"
        >
            {{ 'generalKeywords.delete' | translate }}
        </button>
        @if (displayDeleteAndApplyRoomAmenitiesSetButton) {
            <button
                class="button delete-btn"
                (click)="close('deleteAndApplyRoomAmenitiesSet')"
                [disabled]="data.isWithCompanyConfirmation && confirmationInput !== ('generalKeywords.delete' | translate)"
            >
                {{ 'generalKeywords.deleteAndApplyRoomAmenitiesSet' | translate }}
            </button>
        }
        <button class="button cancel-btn" (click)="close(false)">{{ 'generalKeywords.cancel' | translate }}</button>
    </footer>
</div>
